import file from "./file";
import api from "./api";
const UserData = () => api.post("/user");
const OrganisationData = () => api.post("/organisation");
const ResidualFileUpload = (data) => api.post("/residuals/upload", data);
const ResidualFileGet = (data) => api.post("/residuals/get", data);

const ResidualMassFileUpload = (data) =>
  api.post("/residuals/mass/upload", data);

const GetResidualFileBase64 = (data) =>
  api.post("/residuals/getResidualPdf", data);
const ResidualFileDelete = (data) => api.post("/residuals/file/delete", data);
const OrganisationName = (data) => api.post("/organisationname", data);
const Updateinfo = (url, data) => api.post(url, data);
const UserLogin = (payload) => api.post("/stratus/login", payload);
const Logout = () => api.post("/user/logout");
const getPreapp = (query) => api.post("/preapp", query);
const getPreappById = (data) => api.post("/getPowerappbyId", data);
const Uploads = (id, data) => api.post("/uploads/" + id, data);
const starApp = (data) => api.post("/star_app", data);
const getUser = (id) => api.get("/getUser/" + id);
const addNotes = (id, data) => api.post("/addnote/" + id, data);
const getTodo = (query) => api.get("/get_todo" + query);
const addTodo = (data) => api.post("/addtodo", data);
const updateTodo = (data) => api.post("/update_todo", data);
const deleteTodo = (id) => api.get("/delete_todo/" + id);
const checkUser = (id) => api.get("/check-user/");
const updateImportant = (id) => api.get("/update-important/" + id);
const reviveApplication = (data) => api.post("/revive-application", data);
const updateProgression = (data) => api.post("/update-progression", data);
const resendSignature = (data) =>
  api.post("/resend-signature/" + data.id, data);
const getFiles = (data) => api.post("/get-files", data);
const getMerchantInfo = (data) => api.post("/merchant-info", data);
const getActiveBanks = () => api.get("/active-bank-list");
const getBankAddendums = (data) => api.post("/addendum-list", data);
const getBanks = (data) => api.get("/bank-list", { params: data });
const addBank = (data) => api.post("/add-bank", data);
const updateBank = (data) => api.post("/update-bank", data);
const addAppBank = (data) => api.post("/add-preapp-bank", data);
const getNotes = (data) => api.post("/get-notes", data);
const deleteNote = (id, data) => api.post("/deleteNote/" + id, data);
const bankList = (data) => api.post("/bank-list", data);
const runPdf = (data) => api.post("/re-run/" + data.id, data);
const sendSignature = (data) => api.post("/send-sign/" + data.id, data);
const confirmSignature = (data) => api.post("/confirm-sign/" + data.id, data);
const cancelApp = (data) => api.post("/cancel-app", data);
const copyApp = (data) => api.post("/copy/" + data.id, data);
const changeOwner = (data) => api.post("/updateownership/" + data.id, data);
const cancelSignature = (data) => api.post("/cancel-sign/" + data.id, data);
const GetAllOrganizationsDropdown = () => api.post("/all-organisation-dropdown");
const GetAllOrganizations = (pageNumber, data = null) =>
  api.post("/all-organisation/?page=" + pageNumber, data);
const ExportAllOrganizations = (data = null) =>
  api.post("/export-organization-csv/", data);
const ExportOrganizationEmails = (data = null) =>
  api.post("/export-organization-emails", data);
const GetAllOrganizationsSingleCall = (pageNumber) =>
  api.get("/all-organisation-single-call");
const GetOrganizationById = (id) => api.get("/get-organisation-by-id/" + id);
const deleteOrganization = (id) => api.post("/delete-organization/" + id);
const SearchOrganizationMembers = (organizationId, params) =>
  api.get("/search-organization-members/" + organizationId, {
    params: params,
  });
const AddMemberToOrganization = (id, data) =>
  api.post("/organizations/" + id + "/agent/add", data);
const CreateOrganization = (data) => api.post("/create-organization", data);
const GetAdminUsers = () => api.get("/get-admin-users");
const DeleteMember = (data) => api.post("/delete-member", data);
const UpdateMember = (id, data) => api.post("/update-member/" + id, data);
const UpdateSignatureMember = (data) =>
  api.post("/member/signature/update", data);
const UpdateOrganization = (id, data) =>
  api.post("/update-organization/" + id, data);
const SearchOrganization = (search) =>
  api.get("/search-organization?search=" + search);
const addOrganizationNotes = (id, data) =>
  api.post("/add-organization-note/" + id + "/addnote/", data);
const getOrganizationNotes = (id) => api.post("/organization/get-notes/" + id);
const deleteOrganizationNotes = (id, organization_id) =>
  api.post("/organization/delete-notes/" + id + "/" + organization_id);
const DeleteFile = (data) => api.post("/remove-file", data);
const getZohoList = () => api.post("/get-zoho-users");
const getDepartmentsList = () => api.post("/get-departments-list");
const getOfficeList = (id) => api.post("/organization/get-offices/" + id);
const AddOfficeToOrganization = (id, data) =>
  api.post("/organization/" + id + "/office/add", data);
const UpdateOffice = (organization_id, data) =>
  api.post("/organization/" + organization_id + "/office/update", data);
const DeleteOffice = (data) =>
  api.post("/organization/" + data.organization_id + "/office/delete", data);
const SearchOrganizationOffices = (organizationId, keyword) =>
  api.get("/search-organization-offices/" + organizationId + "?q=" + keyword);
const getBranchesList = (organization_id) =>
  api.post("/office/get-branches/" + organization_id);
const getTemplateList = (organization_id) =>
  api.get("/get-organizations-pricing-templates/" + organization_id);
const AddBranchToOffice = (id, data) =>
  api.post("/office/" + id + "/branch/add", data);
const UpdateBranch = (office_id, data) =>
  api.post("/office/" + office_id + "/branch/update", data);
const DeleteBranch = (data) =>
  api.post("/office/" + data.office_id + "/branch/delete", data);
const DeletePricingTemplate = (id) =>
  api.post("/organization/delete_pricing_template/" + id);
const SearchOfficeBranches = (organizationId, keyword) =>
  api.get("/search-office-branches/" + organizationId + "?q=" + keyword);
const SearchPricingTemplate = (organizationId, keyword) =>
  api.get("/search-pricing-template/" + organizationId + "?q=" + keyword);
const UpdatePricingTemplate = (data) =>
  api.post("/update-pricing-templates", data);
const GetAllAgents = () => api.get("/list-all-agents");
const updatePartnerResidualSplitsDetails = (id, data) =>
  api.post("/residuals/partner/split/" + id + "/detail", data);
const getPartnerResidualSplits = (id) =>
  api.get("/residuals/partner/split/" + id);
const deleteResidualData = (payload) => api.post("/residuals/delete", payload);
const getResidualData = (payload) => api.post("/residuals/data", payload);
const getTempResidualData = (payload) =>
  api.post("/residuals/data/temp", payload);
const getLatestResidualData = (payload) =>
  api.post("/residuals/latest/months", payload);
const getExportCSVLink = (query) => file("/export-csv", query);
const GetEmailData = (slug) => api.get(`/get_email_info/?slug=${slug}`);
const SendLink = (data) => api.post("/send_link/", data);
const GetData = (editSlug) => api.get("/get-data/?editSlug=" + editSlug);
const SendService = (data) => api.post('/send_service', data);
const ListOfPdfs = () => api.get('/list_of_pdfs');
const FlattenListOfPdfs = () => api.get('/flattened_list_of_pdfs');
const generatePDFAndDownload = (data) => api.post('/generate_pdf/download', data);
const EmsBankFiles = (id) => api.get(`/ems_bank_files/${id}`);

const SendServiceHistory = (id) => api.get(`send_service_history/${id}`);
const UpdateMccRecord = (payload) => api.post("/update_mcc_record", payload);

const CreateApplication = (data) => api.post("/save-application", data);
const CreatePrevetApplication = (data) =>
  api.post("/save-prevet-application", data);
const ChangePrevetApplicationStatus = (data) =>
  api.post("/change-prevet-status", data);

const getProcessingAppData = (date) =>
  api.get(
    "/get-processing-app-data?startDate=" +
    date.firstDate +
    "&endDate=" +
    date.lastDate +
    "&usertype=" +
    date.user,
  );
const saveGoals = (data) => api.post("/set-goals", data);
const getGoalData = (data, abortController) => api.post("daily-goal-data", data, {
  signal: abortController?.signal,
});
const getAppMetricsData = (data) => api.post("app-metrics-data", data);
const saveDashboardState = (data) => api.post("save-dashboard-state", data);
const getAnalyticsData = (data) => api.post("analytics-data", data);

const SaveUpdateEquipmentTemplate = (data) =>
  api.post("/save-update-equipment-template", data);
const GetEquipmentTemplate = (data) =>
  api.post("/get-equipment-template", data);
const DeleteEquipmentTemplate = (id) =>
  api.get("/remove-equipment-template/" + id);
const SaveUpdatePricingEquipmentTemplate = (data) =>
  api.post("/save-update-pricing-equipment-template", data);
const GetPricingEquipmentTemplate = (data) =>
  api.post("/get-pricing-equipment-template", data);
const GetPricingEquipmentTemplateById = (id) =>
  api.get("/get-pricing-equipment-template-by-id/" + id);
const DeletePricingEquipmentTemplate = (id) =>
  api.get("/remove-pricing-equipment-template/" + id);
const SendResetPasswordEmail = (data) =>
  api.post("/send-reset-password-email", data);
const ResetPasswordTokenVerify = (data) =>
  api.post("/reset-password-token-verify", data);
const ResetPassword = (data) => api.post("/reset-password", data);
const blankApp = (data) => api.post("blank-app", data);
const getDropUsers = (data) => api.post("/dropdown-users", data);
const GetMccList = (data) => api.post("/get-mcc-list", data);
const ResetPasswordByPcAdmin = (data) =>
  api.post("/reset-pass-by-pc-admin", data);
const orgUsers = () => api.get("/org-filter-users");
const leadOwners = () => api.get("/org-lead-owners");
const retentionReport = (data) => api.post("/retention/report", data);
const UpdateApproval = (data) => api.post("/update-approval", data);
const saveWebhook = (data) => api.post("webhook/save", data);
const logWebHook = (data) => api.post("webhook/logs", data);
const generateWebhookSecret = (data) =>
  api.post("webhook/generate-secret", data);

const MccListWithPaginate = (pageNumber, data = null) =>
  api.post("/mcc/list/?page=" + pageNumber, data);
const TemplateListWithPaginate = (pageNumber, data = null) =>
  api.post("/template/list/?page=" + pageNumber, data);
const AddUpdateMcc = (data) => api.post("/mcc/update", data);
const RemoveMcc = (id) => api.get("/mcc/remove/" + id);
const updateZohoData = (data) => api.post("/update-zoho-data", data);
const updateUwData = (data) => api.post("/update-uw-data", data);

const OrgContractList = (data) => api.post("org-contract/list", data);
const AddOrgContract = (data) => api.post("org-contract/store", data);
const RemoveOrgContract = (id) => api.get("org-contract/remove/" + id);
const GetFileBase64 = (id) => api.get("org-contract/get-file-base64/" + id);
const getUserToMention = (data) => api.post("/get-user-to-mention", data);
const getPricingTemplate = (data) => api.post("get-pricing-template", data);
const undoNote = (data) => api.post("undo-note", data);
const GetUserDetailsById = (id) => api.get("get-user-details-by-id/" + id);
const getAppFileData = (id) => api.get("/get-app-file-data/" + id);

const getProgressionList = () => api.get("/progression-list");
const changeOtpMobileNumber = (data) =>
  api.post("/update-otp-mobile-number", data);
const changeSignerEmail = (data) => api.post("/update-signer-email", data);
const overrideBankDetails = (data) => api.post("/override-bank-details", data);
const GetMCCRecordById = (id) => api.get("/get/mcc/" + id);
const GetBatchData = (data) => api.post("/ems/get-batch-data", data);
const GetTransactionData = (data) => api.post("/ems/transaction/data", data);
const getSubOrganizations = (organization_id) =>
  api.get("sub-organizations", { params: { organization_id } });
const saveSubOrganizations = (data) => api.post("sub-organizations", data);
const searchSubOrg = (data) => api.post("search-sub-org", data);
const saveBankProcess = (data) => api.post("bank-processors", data);
const getEmsOffices = () => api.get("ems-offices");
const getEmsOfficesById = () => api.get("ems-offices-by-id");
const assignPETemplate = (data) => api.post("assign-pe-template", data);

const getEmsRepCodes = () => api.get("ems/get-rep-codes");

const getEmsOfficesByUser = (user_id) =>
  api.get(`ems-offices-by-user/${user_id}`);

//EMS
const getMonthlyBatchSales = (data) =>
  api.post("ems/get-monthly-batch-sales", data);
const transactionLineChart = (data) =>
  api.post("ems/get-transaction-line-chart-data", data);
const getPieChartData = (data) => api.post("ems/get-pie-chart-data", data);
const saveMid = (data) => api.post("ems/save-mid", data);
const getMerchantDetails = (data) => api.post("ems/get-merchant-details", data);
const getMerchantStatement = (data) =>
  api.post("ems/get-merchant-statement", data);

const updateVarSheet = (data, id) => api.post(`update-var-sheet/${id}`, data);
const emsBoot = (data) => api.post("ems/ems-boot", data);
const getEmsBootEquipments = (org_id) =>
  api.get("equipments-for-ems-boot", { params: org_id });
const createEMSBootApp = (data) => api.post("ems/ems-boot/create-app", data);
const createEMSBootAppV2 = (data) => api.post("ems/ems-boot/create-app-v2", data);
const assignPEToApp = (data) => api.post("attach-pricing-equipment", data);
const saveTemplates = (data) => api.post("save-templates", data);
const saveTemplateV2 = (data) => api.post("v2/save-template", data);
const getTemplateById = (id) => api.get(`get-template-by-id/${id}`);
const saveAvailableForTemplates = (data) => api.post("save-available-for-template", data);

const deleteTemplate = (data) => api.post("delete-template", data);

const saveUpdateEquipments = (data) => api.post("save-update-equipments", data);
const getEquipments = (data) => api.get("get-equipments", { params: data });
const deleteEquipments = (data) => api.post("equipment", data);

const addEquipmentCategory = (data) => api.post("equipment/category", data);
const deleteEquipmentCategory = (id) =>
  api.post("equipment/category/delete", { id });
const getEquipmentCategory = () => api.get("equipment/category");

const saveEquipmentBrand = (data) => api.post("save-equipment-brand", data);
const getEquipmentBrand = (data) =>
  api.get("get-equipment-brands", { params: data });
const deleteEquipmentBrand = (data) =>
  api.post("delete-equipment-brands", data);
const cancelMultipleApp = (data) => api.post("/cancel-multiple-app", data);
const changeMultipleOwner = (data) =>
  api.post("/change-owner-multiple-app", data);
const deleteBulkApps = (data) => api.post("/delete-powerapps", data);
const saveOrgEquipment = (data) => api.post("save-org-equipment", data);
const bulkBankDeactivate = (data) => api.post("bulk-bank-deactivate", data);
const getTemplateForApplication = () => api.get("get-template-for-application");
const SearchOrganizations = (data) => api.get("organizations/search", { params: data });

// mcc bulk actions
const mccBulkRemove = (data) => api.post("/mcc/bulk-remove", data);
const mccBulkUpdate = (data) => api.post("/mcc/bulk-update", data);

// v2 routes
const getApplicationData = (editSlug, config = {}) => api.get(`/v2/get-data/${editSlug}`, config);
const getMccLowRisk = (data) => api.post("/v2/get-mcc-low-risk", data);
const salesAppPost = (data) => api.post("/v2/sales-app-post", data);
const getMinimumData = (editSlug) => api.get(`/v2/get-minimum-data/${editSlug}`);
const sendOtp = (editSlug, data) => api.post(`/v2/send-otp/${editSlug}`, data);
const verifyOtp = (editSlug, data) => api.post(`/v2/verify-otp/${editSlug}`, data);
const getCountries = () => api.get("/v2/get-countries");
const getPdfStatus = (data) => api.post("/v2/get-pdf-status", data);
const uploadPdf = (editSlug, data) => api.post(`/v2/upload-pdf/${editSlug}`, data);
const reUploadPdf = (editSlug, data) => api.post(`/v2/re-upload-pdf/${editSlug}`, data);
const uploadSignature = (editSlug, data) => api.post(`/v2/upload-signature/${editSlug}`, data);
const uploadApplicationFiles = (data) => api.post("/v2/upload-application-files", data);
const getUploadedFiles = (data) => api.post("/v2/get-uploaded-files", data);
const deleteUploadedFile = (data) => api.post("/v2/delete-uploaded-file", data);
const getNotesThankyou = (data) => api.post("/v2/get-notes-thankyou", data);
const addNoteThankyou = (data) => api.post("/v2/add-note-thankyou", data);
const undoNoteThankyou = (data) => api.post("/v2/undo-note-thankyou", data);

// dashboard
const getApplicationsData = (data) => api.post("/v2/dashboard/get-applications-data", data);
const getDashboardStatsData = (data) => api.post("/v2/dashboard/get-stats-data", data);
const getActiveMerchants = (data) => api.post("/v2/dashboard/active-merchants", data);
const getTopChargebacks = (data) => api.post("/v2/dashboard/top-chargebacks", data);
// const getIndustriesData = (data) => api.post("/v2/dashboard/get-industries-data", data);
const getIndustriesData = (data, abortController) => 
  api.post("/v2/dashboard/get-industries-data", data, {
    signal: abortController?.signal 
  });
// v2 routes end

export {
  UserData,
  OrganisationData,
  ResidualFileUpload,
  ResidualFileGet,
  ResidualFileDelete,
  OrganisationName,
  Updateinfo,
  UserLogin,
  Logout,
  getPreapp,
  Uploads,
  starApp,
  getPreappById,
  getUser,
  addNotes,
  deleteNote,
  getTodo,
  addTodo,
  updateTodo,
  deleteTodo,
  checkUser,
  updateImportant,
  updateProgression,
  resendSignature,
  reviveApplication,
  getFiles,
  getMerchantInfo,
  getActiveBanks,
  getBankAddendums,
  getBanks,
  addBank,
  updateBank,
  addAppBank,
  getNotes,
  bankList,
  runPdf,
  copyApp,
  changeOwner,
  sendSignature,
  confirmSignature,
  cancelApp,
  cancelSignature,
  GetAllOrganizationsDropdown,
  GetAllOrganizations,
  ExportAllOrganizations,
  GetOrganizationById,
  SearchOrganizationMembers,
  AddMemberToOrganization,
  CreateOrganization,
  GetAdminUsers,
  DeleteMember,
  UpdateMember,
  UpdateSignatureMember,
  UpdateOrganization,
  SearchOrganization,
  addOrganizationNotes,
  getOrganizationNotes,
  deleteOrganizationNotes,
  deleteOrganization,
  DeleteFile,
  getZohoList,
  getDepartmentsList,
  getOfficeList,
  AddOfficeToOrganization,
  UpdateOffice,
  DeleteOffice,
  SearchOrganizationOffices,
  getBranchesList,
  getTemplateList,
  AddBranchToOffice,
  UpdateBranch,
  DeleteBranch,
  DeletePricingTemplate,
  SearchOfficeBranches,
  SearchPricingTemplate,
  GetAllOrganizationsSingleCall,
  updatePartnerResidualSplitsDetails,
  getPartnerResidualSplits,
  getLatestResidualData,
  deleteResidualData,
  getExportCSVLink,
  getResidualData,
  GetEmailData,
  SendLink,
  GetData,
  getProcessingAppData,
  saveGoals,
  getGoalData,
  getAppMetricsData,
  GetAllAgents,
  saveDashboardState,
  getAnalyticsData,
  UpdatePricingTemplate,
  getTempResidualData,
  SaveUpdateEquipmentTemplate,
  GetEquipmentTemplate,
  DeleteEquipmentTemplate,
  GetPricingEquipmentTemplate,
  GetPricingEquipmentTemplateById,
  DeletePricingEquipmentTemplate,
  SaveUpdatePricingEquipmentTemplate,
  SendResetPasswordEmail,
  ResetPasswordTokenVerify,
  ResetPassword,
  CreateApplication,
  CreatePrevetApplication,
  ChangePrevetApplicationStatus,
  blankApp,
  getDropUsers,
  GetMccList,
  ResetPasswordByPcAdmin,
  orgUsers,
  retentionReport,
  UpdateApproval,
  saveWebhook,
  logWebHook,
  generateWebhookSecret,
  MccListWithPaginate,
  TemplateListWithPaginate,
  AddUpdateMcc,
  RemoveMcc,
  SendService,
  ListOfPdfs,
  FlattenListOfPdfs,
  generatePDFAndDownload,
  SendServiceHistory,
  UpdateMccRecord,
  OrgContractList,
  AddOrgContract,
  RemoveOrgContract,
  updateZohoData,
  updateUwData,
  GetFileBase64,
  getUserToMention,
  getPricingTemplate,
  undoNote,
  GetUserDetailsById,
  getAppFileData,
  saveUpdateEquipments,
  getEquipments,
  deleteEquipments,
  ExportOrganizationEmails,
  GetResidualFileBase64,
  getProgressionList,
  changeOtpMobileNumber,
  changeSignerEmail,
  ResidualMassFileUpload,
  overrideBankDetails,
  leadOwners,
  GetMCCRecordById,
  GetBatchData,
  GetTransactionData,
  getSubOrganizations,
  saveSubOrganizations,
  searchSubOrg,
  saveBankProcess,
  getEmsOffices,
  getEmsOfficesById,
  assignPETemplate,
  getEmsOfficesByUser,
  getMonthlyBatchSales,
  transactionLineChart,
  getPieChartData,
  saveMid,
  getMerchantDetails,
  getMerchantStatement,
  updateVarSheet,
  emsBoot,
  getEmsBootEquipments,
  saveTemplates,
  saveAvailableForTemplates,
  deleteTemplate,
  createEMSBootApp,
  createEMSBootAppV2,
  assignPEToApp,
  addEquipmentCategory,
  getEquipmentCategory,
  deleteEquipmentCategory,
  saveEquipmentBrand,
  getEquipmentBrand,
  deleteEquipmentBrand,
  cancelMultipleApp,
  changeMultipleOwner,
  deleteBulkApps,
  EmsBankFiles,
  saveOrgEquipment,
  bulkBankDeactivate,
  mccBulkRemove,
  mccBulkUpdate,
  getEmsRepCodes,
  getApplicationData,
  getMccLowRisk,
  salesAppPost,
  getMinimumData,
  sendOtp,
  verifyOtp,
  getCountries,
  getPdfStatus,
  uploadPdf,
  uploadSignature,
  reUploadPdf,
  uploadApplicationFiles,
  getUploadedFiles,
  deleteUploadedFile,
  getNotesThankyou,
  addNoteThankyou,
  undoNoteThankyou,
  saveTemplateV2,
  getTemplateById,
  getTemplateForApplication,
  getApplicationsData,
  getDashboardStatsData,
  getIndustriesData,
  SearchOrganizations,
  getActiveMerchants,
  getTopChargebacks,
}
